import React from "react";
import { finApi } from "@/lib/financeApi";
import { Empty, ErrorBox, Loading, useLoad } from "@/components/nds/windows/finance/parts";
import { TxTable } from "@/components/nds/windows/finance/OutsideIncomeTab";

export default function InvoiceHistoryTab({ inv }) {
  const [state, load] = useLoad(() => finApi.get("/transactions", { reference_type: "fin_invoices", reference_id: inv.id, page_size: 500 }), [inv.id, inv.status, inv.paid_amount]);
  if (state.loading && !state.data) return <Loading testid="fin-inv-history-loading" />;
  if (state.error) return <ErrorBox testid="fin-inv-history-error" error={state.error} onRetry={load} />;
  return (
    <div data-testid="fin-inv-history-tab" className="p-5 space-y-3">
      <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Payment & correction audit trail · {state.data.total} rows</div>
      {state.data.items.length ? <TxTable testid="fin-inv-history" items={state.data.items} /> : <Empty testid="fin-inv-history-empty">{inv.legacy_import ? `${inv.status === "paid" ? "Paid" : inv.status === "voided" ? "Voided" : "Recorded"} on the old platform · no ledger rows posted.` : "No ledger activity yet."}</Empty>}
    </div>
  );
}
